import type { ReportType } from '@reports/domain/types';
import type { Report } from '@reports/domain/entities';
import { getReportDefinitionByType } from '@reports/application/configs';

export const getReportDefinitionUseCase = () => {
  const execute = (type: ReportType): Report => {
    const reportDefinition = getReportDefinitionByType(type);

    if (!reportDefinition) {
      throw new Error(`Report definition not found for type: ${type}`);
    }

    return reportDefinition;
  };

  return { execute };
};
